import React, { FunctionComponent, useState, useRef, useEffect } from 'react';
import { SanityImage } from '../../../types/common';
import { urlFor } from '../../../utils/imageBuilder';
import RichText from '../../RichText';
import ReadMore from '../../ReadMore';
import { InternalLinkIcon, XIcon } from '../../Icons';
import './styles.scss';

type CardProps = {
  data: {
    image: SanityImage;
    title: string;
    description?: string | null;
    ctaLabel?: string | null;
    popUpContent?: any;
  };
}

const CardPopUp: FunctionComponent<CardProps> = ({ data }) => {
  console.log(data);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const popupRef = useRef<HTMLDivElement>(null);

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
      setIsPopupOpen(false);
    }
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsPopupOpen(false);
      }
    };

    if (isPopupOpen) {
      document.addEventListener('keydown', handleKeyDown);
      document.addEventListener('mousedown', handleClickOutside);
      document.body.classList.add('modal-open');  
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
      document.body.classList.remove('modal-open');
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = '';
    };
  }, [isPopupOpen]);

  return (
    <div className='card'>
      <picture>
        <source media="(min-width:992px)" srcSet={urlFor(data.image).width(500).quality(90).url()} />
        <source media="(min-width:650px)" srcSet={urlFor(data.image).width(1000).quality(90).url()} />
        <img
          src={urlFor(data.image).width(650).quality(100).url()}
          alt={data.image.alt}
        />
      </picture>

      { data.ctaLabel && <p><strong className='card-title'>{data.title}</strong></p> }
      {data.description && (
        <ReadMore>
          <RichText
            value={data.description}
          />
        </ReadMore>
      )}
      
      <button className="primary-button" onClick={togglePopup}>
        { data.ctaLabel ? data.ctaLabel : data.title } 
        <InternalLinkIcon />
      </button>

      {isPopupOpen && (
        <div className="popup" role="dialog" aria-modal="true" aria-labelledby="modal-title">
          <div className="popup-content" ref={popupRef} tabIndex={-1}>

            <button className="close-popup" aria-label='Close modal' onClick={togglePopup}>
              <XIcon />
            </button>

            <h4 id="modal-title">{data.title}</h4>  {/* Adicionei id para o aria-labelledby */}
            <RichText value={data.popUpContent} />
          </div>
        </div>
      )}
    </div>
  );
}

export default CardPopUp;
